import {TranslateService} from '@ngx-translate/core';
import {Injectable} from '@angular/core';
import {Country, ND} from '@pt/pt-models';

@Injectable({
  providedIn: 'root'
})
export class CountryService {
  constructor(private translateService: TranslateService) {
  }

  createCountryOptions() {
    const countryItems = [];
    for (const key in Country) {
      countryItems.push({
        label: this.translateService.instant('COUNTRIES.' + key),
        value: Country[key]
      });
    }

    return {
      items: countryItems,
      bindLabel: 'label',
      bindValue: 'value'
    };
  }

  countryBackEndKeyConvertion(country: string) {
    for (const key in Country) {
      if (Country[key] === country) {
        return 'COUNTRIES.' + key;
      }
    }
    return ND;
  }
}
